import FlexView from "react-flexview";
import React from "react";
import Button from "../../../modules/commons/Button";
import moment from "moment";
import { ACTIVITY_TYPE } from "../../common/Constants";

export const mainPageTableConfig = ({ userAccess, onClick }) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        return page * rowsPerPage + tableMeta.rowIndex + 1;
      },
      setCellProps: () => ({
        style: { width: "5%" },
      }),
    },
  },
  {
    name: "bookingManagementDate",
    label: "Tanggal",
    options: {
      sort: false,
    },
  },
  {
    name: "managementBookingId",
    label: "Nomor Booking",
    options: {
      sort: false,
    },
  },
  {
    name: "customerName",
    label: "Nama Customer",
    options: {
      sort: false,
    },
  },
  {
    name: "waHPNumber",
    label: "No. WA/Telepon",
    options: {
      sort: false,
    },
  },
  {
    name: "plateNumber",
    label: "No. Plat",
    options: {
      sort: false,
    },
  },
  {
    name: "noteProblem",
    label: "Keluhan/Catatan",
    options: {
      sort: false,
    },
  },
  {
    name: "bookingDate",
    label: "Tanggal Booking",
    options: {
      sort: false,
    },
  },
  {
    name: "bookingTime",
    label: "Jam Booking",
    options: {
      sort: false,
    },
  },
  {
    name: "bookingStatus",
    label: "Status Booking",
    options: {
      sort: false,
    },
  },
  {
    name: "managementBookingId",
    label: "Aksi",
    options: {
      sort: false,
      customBodyRender: (val, {rowData}) => {
        const isCanUpdate = userAccess?.updateAccess;
        const isEditDisabled = checkIsBtnSaveDisabled({
          status: rowData?.[9],
          bookingDate: rowData?.[7]
        })
        
        return (
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <ButtonAction onClick={() => onClick(val, ACTIVITY_TYPE.VIEW)} icon="fa-eye" />
            <ButtonAction
              disabled={!isCanUpdate || isEditDisabled}
              onClick={() => {
                if(!isCanUpdate || isEditDisabled){
                  return
                }
                onClick(val, ACTIVITY_TYPE.UPDATE)
              }}
              icon="fa-pencil-alt"
            />
          </FlexView>
        );
      },
    },
  },
];

export const checkIsBtnSaveDisabled = ({status, bookingDate}) => {
  return (
    DISABLED_BUTTON_STATUS.includes(status) ||
    moment().isAfter(moment(bookingDate, "DD-MM-YYYY"), "day")
  );
};

const ButtonAction = ({ onClick, disabled, icon }) => {
  const color = disabled ? "color-grey" : "color-red";
  return (
    <Button
      className="btnAct background-transparent txt-site txt-title"
      type="button"
      disabled={disabled}
      onClick={() => {
        if (disabled) {
          return;
        }
        onClick();
      }}
    >
      <i className={`fa ${icon} ${color}`} />
    </Button>
  );
};

export const INITIAL_DATE = moment().format("DD-MM-YYYY");
export const INITIAL_PAGINATION = {
  page: 1,
  limit: 5,
  totalData: 0,
};

export const formGroup = {
  bookingId: { value: null },
  kodeCabang: { value: null },
  cabang: { value: null },
  managementBookingId: { value: null },
  customerName: { value: null, mandatory: true },
  waHPNumber: { value: null, mandatory: true },
  plateNumber: { value: null, mandatory: true },
  bookingManagementDate: { value: moment().format("DD-MM-YYYY") },
  bookingDate: { value: null, mandatory: true },
  bookingTime: { value: null, mandatory: true },
  noteProblem: { value: null, mandatory: true },
  bookingStatus: { value: null },
};

export const BOOKING_STATUS_OPTIONS = [
  { label: "UNCONFIRMED", value: "UNCONFIRMED" },
  { label: "CONFIRMED", value: "CONFIRMED" },
  { label: "CANCEL BY NM", value: "CANCEL_BY_NM" },
  { label: "CANCEL BY CUSTOMER", value: "CANCEL_BY_CUSTOMER" },
  { label: "SUCCESS", value: "SUCCESS" },
];

export const DISABLED_BUTTON_STATUS = ["CANCEL BY NM", "CANCEL BY CUSTOMER", "SUCCESS"]